import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import quantumHero from '../../assets/imageforabout/quantum-shield-hero.jpg';
import illustImg   from '../../assets/imageforabout/quantum-threat-real.jpg';

const QuantomeAbout = () => {
  useEffect(() => { AOS.init({ duration: 1000 }); }, []);

  return (
    <>
      {/* ── WHAT IS QUANTOME SHIELD ── */}
      <div id="about1" style={{ padding: '80px 0 60px', background: '#fff' }}>
        <div className="container">
          <div className="row" style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>

            <div className="col-xs-12 col-md-6" data-aos="fade-right">
              <img
                src={quantumHero}
                alt="Quantum Security"
                className="img-responsive"
                style={{
                  borderRadius: 24,
                  width: '100%',
                  maxHeight: 380,
                  objectFit: 'cover',
                  boxShadow: '0 8px 40px rgba(30,64,175,0.18)',
                }}
              />
            </div>

            <div className="col-xs-12 col-md-6" data-aos="fade-left">
              <div className="about-text" style={{ paddingLeft: 20 }}>
                <span style={S.eyebrow}>About Quantum Shield</span>
                <h2 style={S.sectionH2}>What is Quantum Shield?</h2>
                <p style={S.para}>
                  Quantum Shield is RedRuby Technologies' quantum-readiness assessment tool — purpose-built to
                  tell you, in seconds, whether your public-facing domain's TLS certificate can survive
                  the cryptographic power of a quantum computer.
                </p>
                <p style={S.para}>
                  Using live OpenSSL-based handshake analysis, we inspect your certificate chain, key
                  algorithm, hash function, and cipher suite against the threat model of{' '}
                  <strong>Shor's Algorithm</strong> — the quantum attack that breaks RSA and ECDSA
                  encryption at scale.
                </p>
                <div style={S.statRow}>
                  {[
                    { n: '2030', label: 'NIST PQC deadline' },
                    { n: '4096+', label: 'Qubits needed to break RSA-2048' },
                    { n: '3',    label: 'NIST-standardised PQC algorithms' },
                  ].map(({ n, label }) => (
                    <div key={label} style={S.statBox}>
                      <div style={S.statNum}>{n}</div>
                      <div style={S.statLabel}>{label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── HOW IT PROTECTS YOU ── */}
      <div id="about123" style={{ padding: '60px 0 80px', background: '#f8fafc' }}>
        <div className="container">
          <div className="row" style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>

            <div className="col-xs-12 col-md-6" data-aos="fade-right">
              <div className="about-text" style={{ paddingRight: 20 }}>
                <span style={S.eyebrow}>Why Act Now</span>
                <h2 style={S.sectionH2}>The Quantum Threat is Real</h2>
                <p style={S.para}>
                  Quantum computers are advancing rapidly. Nation-state actors are already harvesting
                  encrypted data today with the intention of decrypting it once quantum hardware matures —
                  a strategy known as <strong>"harvest now, decrypt later."</strong>
                </p>
                <p style={S.para}>
                  NIST published three post-quantum cryptography standards in 2024: ML-KEM (FIPS 203),
                  ML-DSA (FIPS 204), and SLH-DSA (FIPS 205). Organisations that delay migration risk
                  exposing sensitive data to retroactive decryption.
                </p>
                <div style={S.benefitsList}>
                  {[
                    { icon: 'fa-check-circle', text: 'Instant certificate vulnerability assessment' },
                    { icon: 'fa-check-circle', text: 'NIST PQC-aligned migration guidance' },
                    { icon: 'fa-check-circle', text: 'Downloadable PDF report for your security team' },
                    { icon: 'fa-check-circle', text: 'No installation or sign-up required' },
                  ].map(({ icon, text }) => (
                    <div key={text} style={S.benefitRow}>
                      <i className={`fa ${icon}`} style={{ color: '#16a34a', marginRight: 10, flexShrink: 0 }} />
                      <span style={{ color: '#374151', fontSize: 15 }}>{text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-xs-12 col-md-6" data-aos="fade-left">
              <img
                src={illustImg}
                alt="Quantum Threat"
                className="img-responsive"
                style={{
                  borderRadius: 24,
                  width: '100%',
                  maxHeight: 380,
                  objectFit: 'cover',
                  boxShadow: '0 8px 40px rgba(30,64,175,0.18)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const S = {
  eyebrow: {
    display: 'inline-block',
    background: '#eff6ff', color: '#1e40af',
    borderRadius: 20, padding: '4px 14px',
    fontSize: 12.5, fontWeight: 700, letterSpacing: 0.5,
    marginBottom: 12,
  },
  sectionH2: {
    fontSize: 'clamp(24px,3.5vw,34px)',
    fontWeight: 800, color: '#0f172a',
    lineHeight: 1.25, marginBottom: 18,
  },
  para: {
    fontSize: 15.5, color: '#475569',
    lineHeight: 1.75, marginBottom: 14,
  },
  statRow: {
    display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 28,
  },
  statBox: {
    background: '#f8fafc', border: '1px solid #e2e8f0',
    borderRadius: 12, padding: '14px 18px', flex: '1 1 80px',
    textAlign: 'center',
  },
  statNum: {
    fontSize: 22, fontWeight: 800,
    color: '#1e40af', lineHeight: 1.1,
  },
  statLabel: {
    fontSize: 11.5, color: '#64748b',
    fontWeight: 500, marginTop: 4,
  },
  benefitsList: { display: 'flex', flexDirection: 'column', gap: 12, marginTop: 24 },
  benefitRow: { display: 'flex', alignItems: 'center' },
};

export default QuantomeAbout;
